import React, { useState } from "react";
import { Form, Input, Button, Icon, Select, Descriptions, Badge, Tooltip } from "antd";
import { Beneficiary } from "../../../../models";
import { handleApiExceptions } from "../../../../app_methods";
import { connect } from "react-redux";
import { Text3, Text4 } from "../../../../styles";
import _ from "lodash";
import { VerificationResultDetailsWrapper } from "./styles";
import { COMPARISON_VALIDITY_STATUS } from "../../../../constants";

let VerificationForm = (props) => {
  const [isVerifying, setIsVerifying] = useState(false);
  const [resultDetails, setResultDetails] = useState({});
  const [thresholdPercentage, setThresholdPercentage] = useState(0);
  const { form } = props;
  const { getFieldDecorator } = form;
  const validations = Beneficiary.validations;
  const formTypes = [];
  if (props?.current_user?.ebav && props.current_user.user.permissions.includes("PENNY_DROP")) {
    formTypes.push({ id: "PENNY_DROP_API", label: "Penny Drop" });
  }
  if (props?.current_user?.ebavwfc && props.current_user.user.permissions.includes("ADVANCED_PENNY_DROP")) {
    formTypes.push({ id: "PENNY_DROP_FUZZY_API", label: "Advanced Penny Drop (Name Comparison)" });
  }
  if (props.current_user?.euv && props.current_user.user.permissions.includes("VPA_VERIFICATIONS")) {
    formTypes.push({ id: "VPA_VERIFICATION_API", label: "VPA Verification" });
  }
  if (props.current_user?.eplv) {
    formTypes.push({ id: "PENNYLESS_API", label: "Pennyless Verification" });
  }
  if (props.current_user?.eplv) {
    formTypes.push({ id: "AUTO_VERIFICATION", label: "Auto Verification"});
  }

  const verifyPennyDropFuzzyMatch = async (values) => {
    setIsVerifying(true);
    const response = await Beneficiary.verify_fuzzy_match({
      account_no: values.account_no,
      ifsc: values.ifsc,
      account_holder_name: values.account_holder_name,
      threshold_percentage: values.threshold_percentage
    });
    if (!response.success) {
      setIsVerifying(false);
      handleApiExceptions(response);
      props.onVerify();
      return;
    }
    setResultDetails(response.data);
    setIsVerifying(false);
    props.onVerify();
  };

  const verifyUPIHandle = async (values) => {
    setIsVerifying(true);
    const response = await Beneficiary.verify_vpa({ vpa: values.upi_handle });
    if (!response.success) {
      setIsVerifying(false);
      handleApiExceptions(response);
      props.onVerify();
      return;
    }
    setResultDetails(response.data);
    setIsVerifying(false);
    props.onVerify();
  };

  const verifyBankAccount = async (values) => {
    setIsVerifying(true);
    const response = await Beneficiary.verify_bank_account({
      verification_type: values.verification_type,
      account_no: values.account_number,
      ifsc: values.account_ifsc,
    });
    if (!response.success) {
      setIsVerifying(false);
      handleApiExceptions(response);
      props.onVerify();
      return;
    }
    if (response?.data?.request_status == "failure"){
      handleApiExceptions(response);
    }
    setResultDetails(response.data);
    setIsVerifying(false);
    props.onVerify();
  };

  const onSubmit = (e) => {
    e.preventDefault();
    form.validateFields((err, values) => {
      if (err) return;
      setThresholdPercentage(values.threshold_percentage ? values.threshold_percentage : props?.current_user?.fuzzy_check_threshold_percentage)
      switch (form.getFieldValue("form_type")) {
        case "PENNY_DROP_FUZZY_API":
          verifyPennyDropFuzzyMatch(values);
          break;
        case "PENNY_DROP_API":
          verifyBankAccount({...values, verification_type: "PENNYDROP"});
          break;
        case "VPA_VERIFICATION_API":
          verifyUPIHandle(values);
          break;
        case "PENNYLESS_API":
          verifyBankAccount({...values, verification_type: "PENNYLESS"});
          break;
        case "AUTO_VERIFICATION":
          verifyBankAccount({...values, verification_type: "AUTO"});
          break;
      }
    });
  };

  const renderBankAccountDetailsForm = () => {
    return (
      <div className="w-100">
        <Form.Item label="Account Number">
          {getFieldDecorator("account_number", {
            rules: validations.account_number,
          })(<Input autoComplete="off" prefix={<Icon type="bank" />} />)}
        </Form.Item>
        <Form.Item className="mb-0" label="Account IFSC Code">
          {getFieldDecorator("account_ifsc", {
            rules: validations.ifsc,
            normalize: (input) => (input || "").toUpperCase()
          })(<Input autoComplete="off" prefix={<Icon type="bank" />} />)}
        </Form.Item>
        <div className="mt-3 d-flex justify-content-end">
          <Button type="primary" htmlType="submit" loading={isVerifying}>
            Verify Bank Account
          </Button>
        </div>
      </div>
    );
  };

  const renderUpiDetailsForm = () => {
    return (
      <div>
        <Form.Item label="UPI Handle">
          {getFieldDecorator("upi_handle", {
            rules: validations.upi_handle,
          })(<Input autoComplete="off" id="upi_handle" prefix={<Icon type="qrcode" />} />)}
        </Form.Item>
        <div className="mt-1 d-flex justify-content-end">
          <Button type="primary" loading={isVerifying} htmlType="submit">
            Verify
          </Button>
        </div>
      </div>
    );
  };

  const renderFuzzyCheckForm = () => {
    return (
      <div>
        <div className="row">
          <div className="col-sm-12 col-md-6 col-lg-6">
            <Form.Item autoComplete="off" label="Account Number">
              {getFieldDecorator("account_no", {
                rules: validations.account_number,
              })(<Input autoComplete="off" prefix={<Icon type="bank" />} />)}
            </Form.Item>
          </div>
          <div className="col-sm-12 col-md-6 col-lg-6">
            <Form.Item autoComplete="off" label="Account IFSC">
              {getFieldDecorator("ifsc", {
                rules: validations.ifsc,
                 normalize: (input) => (input || "").toUpperCase()
              })(<Input autoComplete="off" prefix={<Icon type="bank" />} />)}
            </Form.Item>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <Form.Item autoComplete="off" label="Account Holder Name">
              {getFieldDecorator("account_holder_name", {
                rules: validations.account_holder_name,
              })(<Input autoComplete="off" prefix={<Icon type="user" />} />)}
            </Form.Item>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 col-md-6 col-lg-6">
            <Form.Item autoComplete="off" label={renderThresholdPercentLabelIcon()}>
              {getFieldDecorator("threshold_percentage", {
                rules: validations.threshold_percentage,
                  normalize: (input) => (input || "")
              })(<Input autoComplete="off" suffix={<Icon type="percentage" />} />)}
            </Form.Item>
          </div>
        </div>
        <div className="mt-1 d-flex justify-content-end">
          <Button type="primary" htmlType="submit" loading={isVerifying}>
            Verify Match
          </Button>
        </div>
      </div>
    );
  };

  const renderSelectFormType = () => {
    return (
      <div className="w-100">
        <Form.Item label="Select Verification Type" className="w-100">
          {getFieldDecorator("form_type", {
            rules: validations.form_type,
            onChange: () => {
              setResultDetails(false);
            },
          })(
            <Select
              placeholder="Select Verification Type"
            >
              {formTypes.map(
                (formType, index) =>
                  formType && (
                    <Select.Option key={index} value={formType.id}>
                      <div className="d-flex flex-column">
                        <Text4>{formType.label}</Text4>
                      </div>
                    </Select.Option>
                  )
              )}
            </Select>
          )}
        </Form.Item>
      </div>
    );
  };

  const renderForm = {
    PENNY_DROP_FUZZY_API: renderFuzzyCheckForm,
    PENNY_DROP_API: renderBankAccountDetailsForm,
    VPA_VERIFICATION_API: renderUpiDetailsForm,
    PENNYLESS_API: renderBankAccountDetailsForm,
    AUTO_VERIFICATION: renderBankAccountDetailsForm
  };

  const VERIFICATION_STATUS_TYPES = {
    valid: {
      label: "Valid",
      color: "green",
    },
    invalid: {
      label: "Invalid",
      color: "red",
    },
    failure: {
      label: "Invalid",
      color: "red",
    }
    
  };

  const renderCompValLabelIcon = () => {
    return (
      <div className="d-flex align-items-center">
        Comparison Validity
        <Tooltip title={`Comparison percentage must be at least ${thresholdPercentage} to be successful.`}>
          <Icon style={{color: "#1890ff"}} className="ml-2" type="exclamation-circle" />
        </Tooltip>
      </div>
    );
  };
  
  const renderThresholdPercentLabelIcon = () => {
    return (
      <div className="d-inline-flex m-0 align-items-center">
        Match Percentage Threshold
        <Tooltip placement="right" title={`If not provided, match percentage threshold will be considered as ${props?.current_user?.fuzzy_check_threshold_percentage}%`}>
          <Icon style={{color: "#1890ff"}} className="ml-2" type="exclamation-circle" />
        </Tooltip>
      </div>
    );
  };
  
  const renderResultDetails = (result) => {
    return (
      <VerificationResultDetailsWrapper>
        <div className="mt-2">
          <Text3 className="d-block" strong>
            Verification Result
          </Text3>
          <Descriptions
            className="mt-2 mb-3"
            title={false}
            column={1}
            bordered
            size="small"
            style={{ backgroundColor: "#fafafa" }}
          >
            <Descriptions.Item label="Bank Account Status">
              <Badge
                color={VERIFICATION_STATUS_TYPES[result?.status]?.color}
                text={<Text4> {VERIFICATION_STATUS_TYPES[result?.status]?.label} </Text4>}
              />
            </Descriptions.Item>
            <Descriptions.Item strong label="Account Holder Name">
              <Text4 copyable={result?.account_holder_name?.length > 0 && result?.account_holder_name !== "Na"}>
                {result?.account_holder_name?.length !== 0 && result?.account_holder_name !== "Na"
                  ? result.account_holder_name
                  : "Not Applicable"}
              </Text4>
            </Descriptions.Item>
            {result.status !== "valid" && (
              <Descriptions.Item strong label="Reason">
                <Text4>Incorrect Account Details</Text4>
              </Descriptions.Item>
            )}
          </Descriptions>
        </div>

        {result.percentage_match >= 0 ? (
          <div className="mt-2">
            <Text3 className="d-block" strong>
              Name Comparison Result
            </Text3>
            <Descriptions
              className="mt-2"
              title={false}
              column={1}
              bordered
              size="small"
              style={{ backgroundColor: "#fafafa" }}
            >
              <Descriptions.Item label="Comparison Percentage">
                <Text4>{`${result.percentage_match}%`}</Text4>
              </Descriptions.Item>
              <Descriptions.Item label={renderCompValLabelIcon()}>
                <Badge
                  color={COMPARISON_VALIDITY_STATUS[result?.is_matched]?.color}
                  text={<Text4> {COMPARISON_VALIDITY_STATUS[result?.is_matched]?.label} </Text4>}
                />
              </Descriptions.Item>
            </Descriptions>
          </div>
        ) : null}
      </VerificationResultDetailsWrapper>
    );
  };

  return (
    <Form style={{ minHeight: "100px" }} onSubmit={onSubmit}>
      {renderSelectFormType()}
      {typeof renderForm[form.getFieldValue("form_type")] === "function" &&
        renderForm[form.getFieldValue("form_type")]()}
      {!_.isEmpty(resultDetails) && renderResultDetails(resultDetails)}
    </Form>
  );
};

const mapStateToProps = (state) => ({
  current_user: state.userReducer.current_user,
});

VerificationForm = Form.create()(VerificationForm);

export default connect(mapStateToProps)(VerificationForm);
